import { useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowsH, faCodeBranch, faCopy, faFileDownload, faSync, faTrashAlt,
} from '@fortawesome/pro-light-svg-icons'

import { Button, Grid, Tools } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import { confirmAction } from '@functions/entity'
import handleCallbackAction from '@functions/handleCallbackAction'

import useAgencyProviders from '@hooks/useAgencyProviders'
import useProviderPriceList from '@hooks/useProviderPriceList'
import useReporting from '@hooks/useReporting'

interface ProviderPriceListToolsProps {
  providerPriceListPayload: ReturnType<typeof useProviderPriceList>,
}

const ProviderPriceListTools = (props: ProviderPriceListToolsProps) => {
  const {
    providerPriceListPayload: {
      callbacks: {
        archiveProviderPriceList,
        duplicateProviderPriceList: duplicateFn,
        launchBulkReassignAgencies,
        launchForkProviderPriceList,
        syncChangesToForks: syncChangesFn,
      },
      providerPriceList: {
        hidden,
        id,
        is_master,
      },
    },
  } = props

  const pageContext = useContext(PageContext)
  const { callbacks } = pageContext || {}
  const { syncChangesToForks } = callbacks || {}

  const reportingPayload = useReporting({
    allowedReports: ['price_list_details'],
    defaultValues: { provider_price_list_id: id },
    formDeps: [id],
  })

  const {
    callbacks: { generateReport: generateFn },
  } = reportingPayload

  const agencyProviderPayload = useAgencyProviders({
    filters: {
      provider_price_list_id: id,
    },
    performHttpRequests: !!id,
    requestOptions: {
      include_agency_provider_agency: true,
    },
  })

  const { hasFilteredAgencyProviders } = agencyProviderPayload

  const generateReportPayload = {
    callbacks: {
      action: generateFn,
    },
    toastText: 'Report Queued',
  }

  const syncChangesToForksPayload = {
    callbacks: {
      action: syncChangesFn,
    },
    toastText: 'Syncing changes to Forks queued',
  }

  const duplicateProviderPriceListPayload = {
    callbacks: {
      actionFn: duplicateFn,
    },
    options: { shouldRedirect: true },
    strings: {
      actionString: 'duplicate',
      entityName: 'Provider Price List',
    },
  }

  return (
    <Tools>
      {/*
       // @ts-expect-error TS2322 */}
      <Grid gridRowGap="medium">
        <Button
          buttonStyle="secondaryUtility"
          // @ts-expect-error TS2345
          onClick={() => handleCallbackAction(generateReportPayload)}
          icon={<FontAwesomeIcon icon={faFileDownload} />}
          size="medium"
        >
          Download Price List
        </Button>

        {hasFilteredAgencyProviders && (
        <Button
          // @ts-expect-error TS2322
          as="a"
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faArrowsH} />}
          onClick={() => launchBulkReassignAgencies()}
          size="medium"
        >
          Bulk Reassign
        </Button>
        )}

        {is_master && (
        <>
          <Button
            // @ts-expect-error TS2322
            as="a"
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faCodeBranch} />}
            onClick={() => launchForkProviderPriceList()}
            size="medium"
          >
            Fork
          </Button>

          <Button
            // @ts-expect-error TS2322
            as="a"
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faSync} />}
            onClick={() => syncChangesToForks(syncChangesToForksPayload)}
            size="medium"
          >
            Sync Changes
          </Button>
        </>
        )}

        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faCopy} />}
          onClick={() => confirmAction(duplicateProviderPriceListPayload)}
          size="medium"
        >
          Duplicate Price List
        </Button>

        {!hidden && (
        <Button
          // @ts-expect-error TS2322
          as="a"
          buttonStyle="secondaryDestroy"
          icon={<FontAwesomeIcon icon={faTrashAlt} />}
          onClick={() => archiveProviderPriceList(hasFilteredAgencyProviders)}
          size="medium"
        >
          Archive
        </Button>
        )}
      </Grid>
    </Tools>
  )
}

export default ProviderPriceListTools
